import { render, staticRenderFns } from "./RecordsTable.vue?vue&type=template&id=53f2bf38&scoped=true&slot-scope=scope&"
import script from "./RecordsTable.vue?vue&type=script&lang=js&"
export * from "./RecordsTable.vue?vue&type=script&lang=js&"
import style0 from "./RecordsTable.vue?vue&type=style&index=0&id=53f2bf38&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f2bf38",
  null
  
)

export default component.exports